// extracted by mini-css-extract-plugin
export default {"checks":"DomainMonitorChecks_checks__yOdTc","checkRow":"DomainMonitorChecks_checkRow__Patc9"};